/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import React from 'react';

const CustomDateComponent = React.memo((props) => {
  const { value, readOnly } = props;
   if (!value || typeof value !== 'string') {
    return null;
  }
  return (
    <>
      {value && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={
            readOnly
              ? {
                  opacity: 0.85,
                  pointerEvents: 'none',
                  userSelect: 'none',
                  cursor: 'default',
                }
              : undefined
          }
        >
          <span className="">
            {value?.includes('/') ? value : moment(value).format('MM/DD/YYYY')}
          </span>
        </div>
      )}
    </>
  );
});

export default CustomDateComponent;
